import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "workflow-steps-container"
};
const _hoisted_2 = {
  class: "steps-list"
};
const _hoisted_3 = {
  class: "step-info"
};
const _hoisted_4 = {
  key: 0,
  class: "user-cell-wrapper"
};
const _hoisted_5 = {
  key: 1,
  class: "user-cell-wrapper"
};
const _hoisted_6 = {
  key: 1,
  class: "loading"
};
const _hoisted_7 = {
  key: 2,
  class: "no-workflow"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_user_cell = _resolveComponent("user-cell");
  return _ctx.workflow ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workflow.steps, step => {
    return _openBlock(), _createElementBlock("div", {
      key: step.order,
      class: "step-item"
    }, [_createElementVNode("div", _hoisted_3, [!_ctx.workflow.name ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_user_cell, {
      user: _ctx.toUser(step),
      "second-line-content": step.userEmail,
      role: step.role,
      "search-term": ""
    }, null, 8, ["user", "second-line-content", "role"])])) : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(step.groupName), 1))])]);
  }), 128))])])) : _ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('common.loading')), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('workflow.noData')), 1));
}